// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pingflo-tour-demo-flag {
  position: fixed;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 12040;
  pointer-events: none;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 11px;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #f8fafc;
  background: rgba(15, 23, 42, 0.72);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
}

html[data-pingflo-welcome="1"] #root {
  filter: blur(12px);
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

html[data-pingflo-tour="1"] .ps-sidebar-root {
  z-index: 12000;
}

.pingflo-tour-overlay {
  position: fixed;
  inset: 0;
  z-index: 12050;
  pointer-events: none;
}

.pingflo-tour-overlay__dim {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.pingflo-tour-overlay--menu .pingflo-tour-overlay__dim {
  pointer-events: auto;
}

.pingflo-tour-overlay__hole--nav {
  border-radius: 10px;
}

.pingflo-tour-overlay__hole--shell {
  border-radius: 24px;
  box-shadow: none;
  animation: none;
}

.pingflo-tour-overlay--pulse .pingflo-tour-overlay__hole--shell,
.pingflo-tour-overlay--reduced .pingflo-tour-overlay__hole--shell {
  box-shadow: none;
  animation: none;
}

.pingflo-tour-overlay__hole {
  position: absolute;
  pointer-events: none;
  border-radius: 12px;
  box-shadow:
    0 0 0 2px var(--tour-accent, #00d2ff),
    0 0 24px color-mix(in srgb, var(--tour-accent, #00d2ff) 45%, transparent);
  transition: top 0.35s cubic-bezier(0.25, 1, 0.5, 1),
    left 0.35s cubic-bezier(0.25, 1, 0.5, 1),
    width 0.35s cubic-bezier(0.25, 1, 0.5, 1),
    height 0.35s cubic-bezier(0.25, 1, 0.5, 1);
}

.pingflo-tour-overlay--reduced .pingflo-tour-overlay__hole {
  box-shadow: 0 0 0 2px var(--tour-accent, #00d2ff);
}

.pingflo-tour-overlay--pulse .pingflo-tour-overlay__hole {
  animation: pingflo-tour-pulse 1.8s ease-in-out infinite;
}

@keyframes pingflo-tour-pulse {
  0%,
  100% {
    box-shadow:
      0 0 0 2px var(--tour-accent, #00d2ff),
      0 0 16px color-mix(in srgb, var(--tour-accent, #00d2ff) 40%, transparent);
  }
  50% {
    box-shadow:
      0 0 0 4px var(--tour-accent, #00d2ff),
      0 0 28px color-mix(in srgb, var(--tour-accent, #00d2ff) 55%, transparent);
  }
}

.pingflo-tour-card {
  position: fixed;
  z-index: 12060;
  width: min(320px, calc(100vw - 24px));
  padding: 8px 4px 10px;
  border-radius: 0;
  background: transparent;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border: 0;
  box-shadow: none;
  color: #f8fafc;
  pointer-events: none;
}

.pingflo-tour-card__row > :first-child {
  filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.7));
}

.pingflo-tour-card__row {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.pingflo-tour-card__copy h2 {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 650;
  letter-spacing: 0.01em;
  text-shadow:
    0 1px 2px rgba(0, 0, 0, 0.95),
    0 0 14px rgba(0, 0, 0, 0.9),
    0 0 28px rgba(0, 0, 0, 0.7);
}

.pingflo-tour-card__copy p {
  margin: 0;
  font-size: 14px;
  line-height: 1.55;
  color: #f8fafc;
  text-shadow:
    0 1px 2px rgba(0, 0, 0, 0.95),
    0 0 14px rgba(0, 0, 0, 0.9),
    0 0 28px rgba(0, 0, 0, 0.7);
}

.pingflo-tour-card__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 12px;
}

.pingflo-tour-card__step {
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(248, 250, 252, 0.86);
  text-shadow:
    0 1px 2px rgba(0, 0, 0, 0.95),
    0 0 12px rgba(0, 0, 0, 0.85);
}

.pingflo-tour-card__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

.pingflo-tour-card button {
  appearance: none;
  border: 0;
  border-radius: 999px;
  padding: 7px 12px;
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
  pointer-events: auto;
  transition: transform 0.2s cubic-bezier(0.25, 1, 0.5, 1), background 0.2s ease;
}

.pingflo-tour-card button:active {
  transform: scale(0.97);
}

.pingflo-tour-card__ghost {
  background: rgba(15, 23, 42, 0.72);
  color: rgba(248, 250, 252, 0.9);
}

.pingflo-tour-card__secondary {
  background: rgba(15, 23, 42, 0.78);
  color: #fff;
}

.pingflo-tour-card__primary {
  background: var(--tour-accent, #00d2ff);
  color: #06222a;
}

.pingflo-tour-welcome-scrim {
  position: fixed;
  inset: 0;
  z-index: 12045;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  background: rgba(8, 12, 22, 0.42);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
}

.pingflo-tour-welcome-scrim--soft {
  background: rgba(8, 12, 22, 0.28);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.pingflo-tour-welcome {
  position: relative;
  left: auto;
  bottom: auto;
  transform: none;
  z-index: 12046;
  width: min(420px, calc(100vw - 32px));
  padding: 22px 20px 18px;
  border-radius: 22px;
  background: rgba(15, 23, 42, 0.92);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border: 1px solid rgba(0, 210, 255, 0.28);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.38);
  color: #f8fafc;
}

.pingflo-tour-welcome__agents {
  display: flex;
  gap: 8px;
  margin: 10px 0 14px;
}

.pingflo-tour-welcome h2 {
  margin: 8px 0 4px;
  font-size: 18px;
}

.pingflo-tour-welcome p {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: rgba(248, 250, 252, 0.84);
}

.pingflo-tour-welcome__actions {
  display: flex;
  gap: 8px;
  margin-top: 14px;
}

.pingflo-tour-welcome__actions button {
  flex: 1 1;
  border: 0;
  border-radius: 999px;
  padding: 10px 12px;
  font-weight: 700;
  cursor: pointer;
}

.pingflo-tour-card .pingflo-tour-mute {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.72);
  border: 0;
  color: #f8fafc;
  cursor: pointer;
}

.pingflo-tour-replay {
  margin-top: 10px;
  border: 0;
  border-radius: 999px;
  padding: 8px 14px;
  background: rgba(42, 155, 181, 0.16);
  color: #0e7490;
  font-weight: 650;
  cursor: pointer;
}

.pingflo-tour-help {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  border: 1px solid rgba(42, 155, 181, 0.35);
  background: rgba(42, 155, 181, 0.08);
  color: #0e7490;
  font-weight: 700;
  cursor: pointer;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (prefers-reduced-motion: reduce) {
  .pingflo-tour-overlay__hole,
  .pingflo-tour-card button {
    transition: none;
    animation: none;
  }
}

`, "",{"version":3,"sources":["webpack://./src/tour/TourOverlay.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB;;6EAE2E;EAC3E;;;8CAG4C;AAC9C;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE;;IAEE;;+EAE2E;EAC7E;EACA;IACE;;+EAE2E;EAC7E;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB;;;+BAG6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd;;;+BAG6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC;;gCAE8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,8EAA8E;AAChF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,yCAAyC;EACzC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,kCAAkC;EAClC,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,0CAA0C;EAC1C,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":[".pingflo-tour-demo-flag {\n  position: fixed;\n  top: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 12040;\n  pointer-events: none;\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 11px;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #f8fafc;\n  background: rgba(15, 23, 42, 0.72);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);\n}\n\nhtml[data-pingflo-welcome=\"1\"] #root {\n  filter: blur(12px);\n  pointer-events: none;\n  user-select: none;\n}\n\nhtml[data-pingflo-tour=\"1\"] .ps-sidebar-root {\n  z-index: 12000;\n}\n\n.pingflo-tour-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 12050;\n  pointer-events: none;\n}\n\n.pingflo-tour-overlay__dim {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n\n.pingflo-tour-overlay--menu .pingflo-tour-overlay__dim {\n  pointer-events: auto;\n}\n\n.pingflo-tour-overlay__hole--nav {\n  border-radius: 10px;\n}\n\n.pingflo-tour-overlay__hole--shell {\n  border-radius: 24px;\n  box-shadow: none;\n  animation: none;\n}\n\n.pingflo-tour-overlay--pulse .pingflo-tour-overlay__hole--shell,\n.pingflo-tour-overlay--reduced .pingflo-tour-overlay__hole--shell {\n  box-shadow: none;\n  animation: none;\n}\n\n.pingflo-tour-overlay__hole {\n  position: absolute;\n  pointer-events: none;\n  border-radius: 12px;\n  box-shadow:\n    0 0 0 2px var(--tour-accent, #00d2ff),\n    0 0 24px color-mix(in srgb, var(--tour-accent, #00d2ff) 45%, transparent);\n  transition: top 0.35s cubic-bezier(0.25, 1, 0.5, 1),\n    left 0.35s cubic-bezier(0.25, 1, 0.5, 1),\n    width 0.35s cubic-bezier(0.25, 1, 0.5, 1),\n    height 0.35s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n.pingflo-tour-overlay--reduced .pingflo-tour-overlay__hole {\n  box-shadow: 0 0 0 2px var(--tour-accent, #00d2ff);\n}\n\n.pingflo-tour-overlay--pulse .pingflo-tour-overlay__hole {\n  animation: pingflo-tour-pulse 1.8s ease-in-out infinite;\n}\n\n@keyframes pingflo-tour-pulse {\n  0%,\n  100% {\n    box-shadow:\n      0 0 0 2px var(--tour-accent, #00d2ff),\n      0 0 16px color-mix(in srgb, var(--tour-accent, #00d2ff) 40%, transparent);\n  }\n  50% {\n    box-shadow:\n      0 0 0 4px var(--tour-accent, #00d2ff),\n      0 0 28px color-mix(in srgb, var(--tour-accent, #00d2ff) 55%, transparent);\n  }\n}\n\n.pingflo-tour-card {\n  position: fixed;\n  z-index: 12060;\n  width: min(320px, calc(100vw - 24px));\n  padding: 8px 4px 10px;\n  border-radius: 0;\n  background: transparent;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  border: 0;\n  box-shadow: none;\n  color: #f8fafc;\n  pointer-events: none;\n}\n\n.pingflo-tour-card__row > :first-child {\n  filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.7));\n}\n\n.pingflo-tour-card__row {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.pingflo-tour-card__copy h2 {\n  margin: 0 0 4px;\n  font-size: 15px;\n  font-weight: 650;\n  letter-spacing: 0.01em;\n  text-shadow:\n    0 1px 2px rgba(0, 0, 0, 0.95),\n    0 0 14px rgba(0, 0, 0, 0.9),\n    0 0 28px rgba(0, 0, 0, 0.7);\n}\n\n.pingflo-tour-card__copy p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #f8fafc;\n  text-shadow:\n    0 1px 2px rgba(0, 0, 0, 0.95),\n    0 0 14px rgba(0, 0, 0, 0.9),\n    0 0 28px rgba(0, 0, 0, 0.7);\n}\n\n.pingflo-tour-card__meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.pingflo-tour-card__step {\n  font-size: 11px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba(248, 250, 252, 0.86);\n  text-shadow:\n    0 1px 2px rgba(0, 0, 0, 0.95),\n    0 0 12px rgba(0, 0, 0, 0.85);\n}\n\n.pingflo-tour-card__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.pingflo-tour-card button {\n  appearance: none;\n  border: 0;\n  border-radius: 999px;\n  padding: 7px 12px;\n  font-size: 12px;\n  font-weight: 650;\n  cursor: pointer;\n  pointer-events: auto;\n  transition: transform 0.2s cubic-bezier(0.25, 1, 0.5, 1), background 0.2s ease;\n}\n\n.pingflo-tour-card button:active {\n  transform: scale(0.97);\n}\n\n.pingflo-tour-card__ghost {\n  background: rgba(15, 23, 42, 0.72);\n  color: rgba(248, 250, 252, 0.9);\n}\n\n.pingflo-tour-card__secondary {\n  background: rgba(15, 23, 42, 0.78);\n  color: #fff;\n}\n\n.pingflo-tour-card__primary {\n  background: var(--tour-accent, #00d2ff);\n  color: #06222a;\n}\n\n.pingflo-tour-welcome-scrim {\n  position: fixed;\n  inset: 0;\n  z-index: 12045;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 16px;\n  background: rgba(8, 12, 22, 0.42);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n}\n\n.pingflo-tour-welcome-scrim--soft {\n  background: rgba(8, 12, 22, 0.28);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n}\n\n.pingflo-tour-welcome {\n  position: relative;\n  left: auto;\n  bottom: auto;\n  transform: none;\n  z-index: 12046;\n  width: min(420px, calc(100vw - 32px));\n  padding: 22px 20px 18px;\n  border-radius: 22px;\n  background: rgba(15, 23, 42, 0.92);\n  backdrop-filter: blur(18px);\n  -webkit-backdrop-filter: blur(18px);\n  border: 1px solid rgba(0, 210, 255, 0.28);\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.38);\n  color: #f8fafc;\n}\n\n.pingflo-tour-welcome__agents {\n  display: flex;\n  gap: 8px;\n  margin: 10px 0 14px;\n}\n\n.pingflo-tour-welcome h2 {\n  margin: 8px 0 4px;\n  font-size: 18px;\n}\n\n.pingflo-tour-welcome p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.5;\n  color: rgba(248, 250, 252, 0.84);\n}\n\n.pingflo-tour-welcome__actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 14px;\n}\n\n.pingflo-tour-welcome__actions button {\n  flex: 1;\n  border: 0;\n  border-radius: 999px;\n  padding: 10px 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.pingflo-tour-card .pingflo-tour-mute {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border-radius: 999px;\n  background: rgba(15, 23, 42, 0.72);\n  border: 0;\n  color: #f8fafc;\n  cursor: pointer;\n}\n\n.pingflo-tour-replay {\n  margin-top: 10px;\n  border: 0;\n  border-radius: 999px;\n  padding: 8px 14px;\n  background: rgba(42, 155, 181, 0.16);\n  color: #0e7490;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.pingflo-tour-help {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 999px;\n  border: 1px solid rgba(42, 155, 181, 0.35);\n  background: rgba(42, 155, 181, 0.08);\n  color: #0e7490;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .pingflo-tour-overlay__hole,\n  .pingflo-tour-card button {\n    transition: none;\n    animation: none;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
